const productData = {
    "Industrial Elbow": {
      description:
        "Offering you a complete choice of products including MS Pipe Elbow, MS 90 Degree Threaded Elbow, MS Threaded Elbow, Socket Weld Elbow, 45 Degree Threaded Elbow, and 1/4 Inch Forged Elbow.",
      products: [
        {
          title: "MS Pipe Elbow",
          image: "assets/img/products/elbow1.jpg",
          specifications: [
            { label: "Size", value: "3 Inch" },
            { label: "Material", value: "MS" },
            { label: "Type", value: "Threaded" },
            { label: "Elbow Bend Angle", value: "45 degree" },
            { label: "Usage/Application", value: "Industrial" },
            { label: "Country of Origin", value: "Made in India" },
            { label: "Packaging Type", value: "Box" },
            { label: "Technique", value: "Hot Rolled" },
            { label: "Brand", value: "Krishna Forge Fitting" },
          ],
          description:
            "These unequal elbows have to pass through various quality parameters to ensure a flawless range. The provided unequal elbows are smoothly manufactured at our unit according to market guidelines.",
        },
        {
          title: "MS 90 Degree Threaded Elbow",
          image: "assets/img/products/elbow2.jpg",
          specifications: [
            { label: "Size", value: "4 Inch" },
            { label: "Material", value: "MS" },
            { label: "Type", value: "Threaded" },
            { label: "Elbow Bend Angle", value: "45 degree" },
            { label: "Usage/Application", value: "Industrial" },
            { label: "Country of Origin", value: "Made in India" },
            { label: "Packaging Type", value: "Box" },
            { label: "Technique", value: "Hot Rolled" },
            { label: "Brand", value: "Krishna Forge Fitting" },
          ],
          description:
            "Being a leading firm in this industry, we are manufacturing a high-quality range of 90 Degree Threaded Elbow.",
          details: "NPT 2000 Class 1/2 to 4",
          features: ["Rust resistance", "Dimensional accuracy", "High strength"],
        },
        {
          title: "MS Threaded Elbow",
          image: "assets/img/products/elbow3.jpg",
          specifications: [
            { label: "Size", value: "2 Inch" },
            { label: "Material", value: "MS" },
            { label: "Usage/Application", value: "Industrial" },
            { label: "Brand", value: "Krishna Forge Fitting" },
            { label: "Technique", value: "Hot Rolled" },
            { label: "Country of Origin", value: "Made in India" },
            { label: "Packaging Type", value: "Box" },
          ],
          description:
            "Riding on unfathomable volumes of industrial expertise, we are engaged in manufacturing a broad assortment of MS Threaded Elbow.",
        },
        {
          title: "Socket Weld Elbow",
          image: "assets/img/products/elbow4.jpg",
          specifications: [
            { label: "Size", value: "3 Inch" },
            { label: "Material", value: "MS" },
            { label: "Usage/Application", value: "Industrial" },
            { label: "Brand", value: "Krishna Forge Fitting" },
            { label: "Country of Origin", value: "Made in India" },
            { label: "Packaging Type", value: "Box" },
            { label: "Technique", value: "Hot Rolled" },
          ],
          description:
            "We are a unique name in the industry, devoted towards manufacturing the best quality array of Socket Weld Elbow.",
            details: "Dimensions Socket Weld Elbows – NPS 1/2 to 4 – 90°",
        },
        {
          title: "45 Degree Threaded Elbow",
          image: "assets/img/products/elbow5.jpg",
          specifications: [
            { label: "Size", value: "3 Inch" },
            { label: "Material", value: "MS" },
            { label: "Usage/Application", value: "Industrial" },
            { label: "Brand", value: "Krishna Forge Fitting" },
            { label: "Technique", value: "Hot Rolled" },
            { label: "Packaging Type", value: "Box" },
            { label: "Surface Treatment", value: "Galvanized" },
            { label: "Country of Origin", value: "Made in India" },
          ],
          description:
            "We are successfully engaged in manufacturing of high quality 45 Degree Threaded Elbow for our valued clients.",
        },
        {
          title: "1/4 Inch Forged Elbow",
          image: "assets/img/products/elbow6.jpg",
          specifications: [
            { label: "Size", value: "1/4 Inch" },
            { label: "Material", value: "MS" },
            { label: "Usage/Application", value: "Industrial" },
            { label: "Technique", value: "Hot Rolled" },
            { label: "Packaging Type", value: "Box" },
            { label: "Country of Origin", value: "Made in India" },
          ],
          description:
            "We are successfully engaged in manufacturing of high quality of 1/4 Inch Forged Elbow for our valued clients.",
        },
        {
          title: "2 Inch Stainless Steel Elbow",
          image: "assets/img/products/elbow7.jpg",
          specifications: [
            { label: "Size", value: "2 Inch" },
            { label: "Material", value: "SS" },
            { label: "Usage/Application", value: "Industrial" },
            { label: "Technique", value: "Hot Rolled" },
            { label: "Packaging Type", value: "Box" },
            { label: "Surface Finish", value: "Polished" },
            { label: "Country of Origin", value: "Made in India" },
          ],
          description:
            "We are successfully engaged in manufacturing of high quality of 2 Inch Stainless Steel Elbow for our valued clients.",
        },
        {
          title: "MS Street Elbow",
          image: "assets/img/products/elbow8.jpg",
          specifications: [
            { label: "Size", value: "3 Inch" },
            { label: "Material", value: "MS" },
            { label: "Usage/Application", value: "Industrial" },
            { label: "Technique", value: "Hot Rolled" },
            { label: "Packaging Type", value: "Box" },
            { label: "Country of Origin", value: "Made in India" },
          ],
          description:
            "We are successfully engaged in manufacturing of high quality of MS Street Elbow for our valued clients.",
        },
      ],
    },
    "Industrial Tee": {
      description:
      "We are a leading Manufacturer of MS Socket Weld Tee, Stainless Steel Unequal Tee, MS Forged Tee, Steel Pipe Tee, Stainless Steel Equal Tee and GI Screwed Tee from Rajkot, India.",
      products: [
        {
          title: "MS Socket Weld Tee",
          image: "assets/img/products/tee1.jpg",
          specifications: [
            { label: "Size", value: "2 Inch" },
            { label: "Usage/Application", value: "Industrial" },
            { label: "Material", value: "MS" },
            { label: "Brand", value: "Krishna Forge Fitting" },
            { label: "Technique", value: "Hot Rolled" },
            { label: "Packaging Type", value: "Box" },
            { label: "Surface Treatment	", value: "Galvanized" },
            { label: "Country of Origin", value: "Made in India" },
          ],
          description:
            "With our expertise and trustworthiness, we are engaged in manufacturing an optimum quality range of MS Socket Weld Tee.",
            details: "1/2 to 4 Inch",
        },
      ]
    }
  };
  
  export default productData;
  